import { Box, Chip, FormControlLabel, Radio, Typography } from "@mui/material";
import { FC } from "react";
import { ICPAnalysisMethod } from "../../../types";
import { ICPCustomerListUploadInput } from "./ICPCustomerListUploadInput";

interface Props {
  selectedMethod: ICPAnalysisMethod;
  onViewAnalysis: () => void;
}

/**
 * Customer list upload method option component
 * Displays the customer list upload option with its input component when selected
 */
export const ICPCustomerListMethodOption: FC<Props> = ({
  selectedMethod,
  onViewAnalysis,
}) => {
  const isSelected = selectedMethod === ICPAnalysisMethod.CUSTOMER_LIST;

  return (
    <Box padding={2}>
      <FormControlLabel
        value={ICPAnalysisMethod.CUSTOMER_LIST}
        control={<Radio />}
        label={
          <Box sx={{ display: "flex", alignItems: "center", gap: 1 }}>
            <Typography variant="body1">Customer List Upload</Typography>
            <Chip
              label="Recommended"
              size="small"
              sx={{
                fontSize: "12px",
              }}
            />
          </Box>
        }
      />

      <Box marginLeft="31px">
        <Typography variant="body1" color="text.secondary">
          Upload your customer data to identify the key characteristics that
          define your ideal customers.
        </Typography>

        {isSelected && (
          <ICPCustomerListUploadInput onViewAnalysis={onViewAnalysis} />
        )}
      </Box>
    </Box>
  );
};
